import React from 'react';
import background from '../../assets/isro.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoIsro extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="NEAR SPACE"
        subtag="Bangalore, India"
        description="ISRO"
        paragraph="The Indian Space Research Organisation is the space agency of the Government of India."
        background={background}
     />
  
  );
 }
}   

export default InfoIsro;